/**
 * Converts a camelCase string to snake_case.
 *
 * @param str - The camelCase string to convert
 * @returns The snake_case equivalent
 */
export function camelToSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

/**
 * Recursively converts all object keys from camelCase to snake_case.
 *
 * The SSE stream uses protobuf's default JSON encoding (camelCase keys)
 * while our generated TypeScript types use snake_case (from OpenAPI spec
 * with json_names_for_fields=false). This function bridges the mismatch.
 *
 * @param obj - The value to convert (objects, arrays, or primitives)
 * @returns The value with all object keys converted to snake_case
 */
export function convertKeysToSnakeCase(obj: unknown): unknown {
  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(convertKeysToSnakeCase);
  }
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
    result[camelToSnakeCase(key)] = convertKeysToSnakeCase(value);
  }
  return result;
}
